// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"92a315f151da5016c01c","966":"3c40dc0bd68b80f95b7b"}[chunkId] + ".js";
};